
/**
 * Open the contact form modal from any element with #contact_form_btn,
 * even when it lives in the page content (Gutenberg button block) and
 * therefore has no data-bs-toggle attributes.
 * 
 *
 */

const panelBtn = document.querySelector('#contact_form_btn')
const closeBtn = document.querySelector('.contact-modal__close')

const formPanel = document.querySelector(".form__panel");

if (panelBtn && formPanel) {
    panelBtn.addEventListener('click', () => {
        formPanel.classList.add('open')
    })
}

if (closeBtn && formPanel) {
    closeBtn.addEventListener('click', () => {
        formPanel.classList.remove('open')
    })
}